import { isBefore, isAfter, getStartOfSchoolYear, getNow } from '@kathondvla/sri-client/date-utils';
import { formatPhoneNumber } from '@kathondvla/sri-client/contactdetail-utils';
import { sriClient } from 'ReduxLoop/utils/apiConfig';
import {
  addErrorNotification,
  addWarningNotification,
  addSuccessNotification,
  removeNotification,
} from 'ReduxLoop/notifications/notificationActions';
import { fetchUser } from 'ReduxLoop/user/userActions';
import {
  fetchOuData,
  getOuByInstitutionNumber,
  sendBatch,
  validateInstitutionNumber,
  getAllPhysicallocationsInCity,
  fetchLegalForms,
  getResponsibilities,
  getWorkgroup,
  deleteWorkgroup,
  fetchCountries,
} from './dataAccess';
import { transformOu, getFormModel } from './transformations';
import { calculateChanges, deleteOu } from './save';
import { patterns } from '../../module/regexPatterns';
import { OU_TYPE_CONFIG } from './typeConfig';
import { extractCompanyNumberFromVat, importViesOrg, validateCompanyNumber, validateVatNumber } from './vatAndCompanyNumberUtils';
import { fetchPeppolDirectoryResponse } from 'ReduxLoop/utils/accountingDetailsUtils';

export class MyOuAdminForm {
  constructor($scope, $state, $stateParams, $location, $ngRedux, settings, $compile, $uibModal) {
    'ngInject';

    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$ngRedux = $ngRedux;
    this.settings = settings;
    this.sriClient = sriClient;
    this.$compile = $compile;
    this.$uibModal = $uibModal;
    this.removeIcon = require('Img/cross.svg');
    this.searchParams = {
      types: 'organisational_unit',
      expand: 'full',
      limit: 50,
    };
    this.directSearchParams = {};
    this.ouData = {};
    this.patterns = patterns;

    this.unsubscribe = this.$ngRedux.connect((state) => ({
      user: state.vm.user,
      notificationList: state.vm.notifications,
    }))(this);
  }

  async $onInit() {
    this.$ngRedux.dispatch(fetchUser()).then(() => {
      if (!this.user.adminForOuTypes) {
        this.$state.go('home');
      } else {
        this.OU_TYPES = Object.entries(OU_TYPE_CONFIG)
          .filter(([key, value]) => this.user.adminForOuTypes.has('ALL') || this.user.adminForOuTypes.has(key))
          .map(([key, value]) => ({ value: key, label: value.label }));
        this.reset();
      }
    });
    if (this.$stateParams.nr) {
      const ou = await getOuByInstitutionNumber(this.$stateParams.nr);
      if (ou) {
        this.ouSelected(ou);
      }
    }
    if (this.$stateParams.href) {
      this.ouSelected({
        $$meta: { permalink: this.$stateParams.href },
        key: this.$stateParams.href.split('/').pop(),
      });
    }

    const handleUrlChange = async (event) => {
      const nrMatch = event.currentTarget.location.hash.match(/nr=(\d+)/);
      const hrefMatch = event.currentTarget.location.hash.match(/href=(%2F(?:sam|kathondvla)%2Forganisationalunits%2F(?:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))/);
      const urlInstitutionNumber = nrMatch && nrMatch.length >= 2 && nrMatch[1];
      const urlHref = hrefMatch && hrefMatch.length >= 2 && decodeURIComponent(hrefMatch[1]);
      if (this.ou && !urlInstitutionNumber && !urlHref) {
        this.ouData = {};
        this.ouType = null;
        this.reset();
        this.$scope.$apply();
      }
      if (
        urlInstitutionNumber &&
        (!this.ou || urlInstitutionNumber !== this.ou.institutionNumber)
      ) {
        console.log('[url watcher] instititution number changed by URL!');
        const ou = await getOuByInstitutionNumber(urlInstitutionNumber);
        if (ou) {
          this.ouType = null;
          this.searchParams.organisationalUnitTypes = null;
          this.directSearchParams.type = null;
          this.ouSelected(ou);
        }
      }
      if (
        urlHref &&
        (!this.ou || urlHref !== this.ou.href)
      ) {
        console.log('[url watcher] href changed by URL!');
        this.ouType = null;
        this.searchParams.organisationalUnitTypes = null;
        this.directSearchParams.type = null;
        this.ouSelected({
          $$meta: { permalink: urlHref },
          key: urlHref.split('/').pop(),
        });
      }
    };
    window.addEventListener('popstate', handleUrlChange);
  }

  calculateVmExternal() {
    this.calculateVm();
  }

  calculateVm(useOuEndDateAsReference) {
    console.log('ouData', this.ouData);
    this.ou = this.ouData.ouResource
      ? transformOu(
          this.ouData,
          this.pendingResources,
          useOuEndDateAsReference ? this.ouData.ouResource.endDate : this.formModel.endDate
        )
      : null;
    console.log('vm', this.ou);
  }

  reset() {
    this.ouTypeConfig = OU_TYPE_CONFIG[this.ouType];
    this.dirtyResources = {};
    this.validations = {
      endDateErrors: [],
      institutionNumberErrors: [],
      phoneErrors: [],
      vatNumberErrors: [],
      companyNumberErrors: [],
      descriptionErrors: [],
    };
    this.pendingResources = {
      relations: {},
      locations: {},
      physicalLocations: {},
    };
    this.pendingLinks = {};
    this.calculateVm(true);
    if (this.rawLegalFormList) {
      this.legalFormList = this.ou && this.ou.legalOrganisationalForm
        ? [{ $$meta: { permalink: null }, code: '[rechtsvorm verwijderen]' }, ...this.rawLegalFormList]
        : this.rawLegalFormList;
    }
    this.formModel = this.ou ? getFormModel(this.ou) : {};
    console.log('formModel', this.formModel);
    this.calculatePeppolWarningMsg();
    this.hasNewNameInTheFuture = this.ou && this.ou.nameHistory.some((name) => name.isFuture);
    this.showNameHistory = this.hasNewNameInTheFuture;
    this.nameHasChanged = false;
    this.hasNewSeatInTheFuture = this.ou && this.ou.seatHistory.some((seat) => seat.isFuture);
    this.showSeatHistory = this.hasNewSeatInTheFuture;
    this.addressHasChanged = false;
    this.viesVatNumber = null;
    this.hasBelgianOndernemingsnummer = this.formModel.companyNumber && this.formModel.companyNumber.match(/^\d{4}\.\d{3}\.\d{3}$/);

    // Broadcast the reset event
    this.$scope.$broadcast('resetOuAdminForm');
  }

  ouTypeChanged() {
    this.$scope.$broadcast('resetFormValidation');
    if (this.searchParams.organisationalUnitTypes) {
      this.$location.search('nr', []);
      this.$location.search('href', []);
      this.ouData = {};
      this.reset();
    }
    this.searchParams.organisationalUnitTypes = this.ouType === 'EXTERN' ? 'ANDERE' : this.ouType;
    this.directSearchParams.type = this.ouType;
    this.ouTypeConfig = OU_TYPE_CONFIG[this.ouType];
    this.timeToBeInSync = 'een uur';
    this.directSearchPath = `/${this.ouTypeConfig.domain}/organisationalunits`;
    this.$compile(document.getElementById('ou-admin-form-ref'))(this.$scope);
  }

  ouSelected = async (searchDocument) => {
    this.$scope.$broadcast('resetFormValidation');
    const permalink = searchDocument.$$meta.permalink.startsWith('/sam') ? searchDocument.$$meta.permalink : `/kathondvla/organisationalunits/${searchDocument.key}`;
    this.ouData = await fetchOuData(permalink);
    if (
      searchDocument.institutionNumber &&
      (!this.$stateParams.nr || this.$stateParams.nr !== searchDocument.institutionNumber)
    ) {
      this.$location.search('nr', searchDocument.institutionNumber);
      this.$location.search('href', []);
    } else if (!searchDocument.institutionNumber && (!this.$stateParams.href || this.$stateParams.href !== permalink)) {
      this.$location.search('nr', []);
      this.$location.search('href', permalink);
    }
    if (!this.ouType) {
      this.ouType = this.ouData.ouResource.type;
      this.ouTypeChanged();
    }
    if (!this.rawLegalFormList && OU_TYPE_CONFIG[this.ouType].components.legalForm) {
      this.rawLegalFormList = await fetchLegalForms();
    }
    if (OU_TYPE_CONFIG[this.ouType].allowInternational) {
      if (!this.countryList) {
        this.countryList = await fetchCountries();
      }
      const mail = this.ouData.contactDetails.find((cd) => cd.type === 'MAIL');
      const countryCode = mail ? mail.value.country : 'be';
      this.country = this.countryList.find((country) => country.key === countryCode);
    }
    this.reset();
    this.$scope.$apply();
  };

  // ++++++++++++++++++++++++++++ SAVE ++++++++++++++++++++++++++++

  async onSubmit() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;
    this.submitAttempted = true;
    if (
      !this.ouAdminForm.valid ||
      Object.values(this.validations).some((errorList) => errorList.length > 0)
    ) {
      this.$ngRedux.dispatch(
        addErrorNotification(
          'Niet alle velden zijn correct ingevuld. Kijk de gemarkeerde velden na'
        )
      );
      this.isSaving = false;
      return;
    }
    try {
      const physicalLocationsInCityOfMail =
        this.formModel.mail && (this.dirtyResources.mail || this.dirtyResources.dateOfAddressChange)
          ? await getAllPhysicallocationsInCity(this.formModel.mail.cityHref, 'DOMAIN')
          : null;
      const { batch, newOuData } = calculateChanges({
        ouType: this.ouType,
        ouModel: this.ou,
        formModel: this.formModel,
        dirtyResources: this.dirtyResources,
        pendingResources: this.pendingResources,
        ouData: this.ouData,
        physicalLocationsInCityOfMail,
        legalFormList: this.legalFormList,
      });
      if (batch.length === 0) {
        this.$ngRedux.dispatch(addWarningNotification('Er zijn geen wijzigingen'));
        this.isSaving = false;
        return;
      }
      await sendBatch(batch);
      this.$ngRedux.dispatch(addSuccessNotification('De wijzigingen zijn succesvol opgeslagen.'));
      if (!this.ou) {
        this.ouSelected({
          ...newOuData.ouResource,
          institutionNumber: this.formModel.institutionNumber,
        });
        return;
        // this.$state.go('.', { nr: this.formModel.institutionNumber });
      }
      this.ouData = newOuData;
      this.reset();
    } catch (error) {
      console.error(error);
      if (error.message === 'not.allowed.to.delete.seat') {
        this.$ngRedux.dispatch(addErrorNotification('Een instelling moet ten allen tijde een zetel hebben. Je kan het adres niet verwijderen.'));
      } else if (error.message === 'first.seat.startDate.should.be.ou.startDate') {
        this.$ngRedux.dispatch(addErrorNotification('De startdatum van de eerste zetel moet gelijk zijn aan de startdatum van de instelling.'));
      } else if (error.status === 403) {
        this.$ngRedux.dispatch(addErrorNotification('Je hebt niet de juiste rechten om deze actie uit te voeren'));
      } else if (error.status === 409 && error.body && Array.isArray(error.body)) {
        try {
          error.body
          .filter((obj) => obj.status === 409)
          .forEach((obj) => {
            obj.body.errors.forEach((err) => {
              if (err.code === 'name.not.unique') {
                const duplicate = err.duplicates[0].organisationalUnit;
                const nameType  = err.duplicates[0].type === 'OFFICIAL' ? 'naam' : 'korte naam';
                this.$ngRedux.dispatch(addErrorNotification(`Er is al een organisatie van type ${duplicate.type} met dezelfde ${nameType}.`));
              }
              this.$ngRedux.dispatch(addErrorNotification(err.message || err.msg, err.code));
              console.error(`${err.code}: ${err.message || err.msg}:`, { hrefs: err.hrefs, document: obj.body.document });
            })
          });
        } catch (logicErr) {
          console.error(logicErr);
          this.$ngRedux.dispatch(addErrorNotification('Er is een onverwachte fout opgetreden'));
        }
      } else {
        this.$ngRedux.dispatch(addErrorNotification('Er is een onverwachte fout opgetreden'));
      }
    } finally {
      this.isSaving = false;
    }
  }

  // ++++++++++++++++++++++++++++ OU DETAILS ++++++++++++++++++++++++++++

  toggleRealTime() {
    this.searchRealTime = !this.searchRealTime;
  };

  nameChanged(e, value) {
    this.dirtyResources.ou = true;
    this.formModel.name = value;
    this.showNameHistory = true;
    if (this.ou && value !== this.ou.name) {
      this.nameHasChanged = true;
    }
  }

  dateOfNameChangeChanged(e, value) {
    this.formModel.dateOfNameChange = value;
  }

  shortNameChanged(e, value) {
    this.dirtyResources.ou = true;
    this.formModel.shortName = value;
    if (this.ou && value !== this.ou.shortName && this.ouTypeConfig.components.shortName.historical) {
      this.nameHasChanged = true;
    }
  }

  callNameChanged(e, value) {
    this.dirtyResources.ou = true;
    this.formModel.callName = value;
  }

  descriptionChanged() {
    this.dirtyResources.ou = true;
    this.validations.descriptionErrors = [];
    if (this.formModel.description) {
      const byteLength = new Blob([this.formModel.description]).size;
      if (byteLength > 1024) {
        this.validations.descriptionErrors.push({
          code: 'max.byte.length',
          message: `De beschrijving is te lang (${byteLength} bytes). Maximum is 1024 bytes.`,
        });
      }
    }
  }

  startDateChanged(e, value) {
    this.dirtyResources.ou = true;
    this.formModel.startDate = value;
  }

  endDateChanged(e, value) {
    this.dirtyResources.ou = true;
    this.validations.endDateErrors = [];
    this.formModel.endDate = value;
    if (isBefore(value, this.formModel.startDate)) {
      this.validations.endDateErrors = [
        { message: 'De einddatum mag niet voor de startdatum liggen.' },
      ];
    }
    if (
      this.ouAdminForm.formGroups.einddatum.valid &&
      this.validations.endDateErrors.length === 0 &&
      isBefore(value, this.ouData.ouResource.endDate)
    ) {
      const affectedRelations = [];
      this.ouTypeConfig.components.relations.forEach((relationConfig) => {
        const relVm = this.ou.relations[relationConfig.key];
        if (relationConfig.isRequired) {
          if ([...relVm.currentOus].some((relation) => isAfter(relation.resource.endDate, value))) {
            this.validations.endDateErrors = [
              { message: `Relaties van type ${relationConfig.label} moeten ten alle tijde een actieve relatie hebben met een ${this.ouTypeConfig.label} hebben. Ken eerst een ander ${this.ouTypeConfig.label} toe, voordat je dit ${this.ouTypeConfig.label} beëindigd.` },
            ];
          }
        } else {
          if (relVm.currentOu) {
            affectedRelations.push(relVm.currentOu.resource);
          }
          if (relVm.currentOus) {
            relVm.currentOus.forEach((relation) => {
              affectedRelations.push(relation.resource);
            });
          }
          relVm.futureOus.forEach((relation) => {
            affectedRelations.push(relation.resource);
          });
        }
      });
      affectedRelations.forEach((relation) => {
        if (isAfter(relation.endDate, value)) {
          this.pendingResources.relations[relation.$$meta.permalink] = {
            ...relation,
            endDate: value,
          };
        }
      })
      this.ou.locations
        .filter((loc) => isAfter(loc.endDate, value) || (!value && loc.endDate === this.ou.endDate))
        .forEach((loc) => {
          this.pendingResources.locations[loc.resource.$$meta.permalink] = {
            ...loc.resource,
            endDate: value,
          };
        });
      this.calculateVm();
    }
  }

  async institutionNumberChanged(e, value) {
    this.validations.institutionNumberErrors = [];
    this.formModel.institutionNumber = value;
    if (this.ouAdminForm.formGroups.instellingsnummer.valid) {
      this.validations.institutionNumberErrors = await validateInstitutionNumber(value);
    }
  }

  companyNumberChanged(e, value) {
    this.dirtyResources.companyNumber = true;
    const digits = value.replace(/\D/g, '');
    if (digits.length === 10 && this.formModel.mail?.country === 'be') {
      this.hasBelgianOndernemingsnummer = true;
      this.formModel.companyNumber = `${digits.slice(0, 4)}.${digits.slice(4, 7)}.${digits.slice(7, 10)}`;
    } else {
      this.formModel.companyNumber = value;
    }
    this.validations.companyNumberErrors = validateCompanyNumber(this.formModel.companyNumber, this.formModel.mail?.country);
    this.validations.vatNumberErrors = validateVatNumber(this.formModel.vatNumber, this.formModel.mail?.country, this.formModel.companyNumber);
    if (this.validations.companyNumberErrors.length === 0) {
      fetchPeppolDirectoryResponse(this.formModel.companyNumber.replace(/\./g, '')).then((peppolValidation) => {
        this.ou.isKnownInPeppolDirectory = peppolValidation ? !!peppolValidation.matches.length : null;
        this.calculatePeppolWarningMsg();
        this.$scope.$apply();
      });
    }
  }

  vatNumberChanged(e, value) {
    this.validations.vatNumberErrors = [];
    this.dirtyResources.vatNumber = true;
    this.formModel.vatNumber = value;
    if (value && this.ouAdminForm.formGroups['btw-nummer'].valid) {
      const companyNumber = extractCompanyNumberFromVat(value);
      if (companyNumber && !this.formModel.companyNumber) {
        this.formModel.companyNumber = companyNumber;
        this.dirtyResources.companyNumber = true;
        fetchPeppolDirectoryResponse(this.formModel.companyNumber.replace(/\./g, '')).then((peppolValidation) => {
          this.ou.isKnownInPeppolDirectory = peppolValidation ? !!peppolValidation.matches.length : null;
          this.calculatePeppolWarningMsg();
          this.$scope.$apply();
        });
      }
      this.validations.vatNumberErrors = validateVatNumber(value, this.formModel.mail?.country, this.formModel.companyNumber)
    } 
  }

  legalFormChanged() {
    this.dirtyResources.legalForm = true;
  }

  // ++++++++++++++++++++++++ CONTACT DETAILS ++++++++++++++++++++++++

  emailChanged(e, value) {
    this.dirtyResources.email = true;
    this.formModel.email = value;
  }

  phoneChanged(e, value) {
    this.dirtyResources.phone = true;
    this.validations.phoneErrors = [];
    this.formModel.phone = value;
    if (value && this.ouAdminForm.formGroups.phone.valid) {
      try {
        this.formModel.phone = formatPhoneNumber(value);
      } catch (error) {
        this.validations.phoneErrors.push({
          code: 'invalid.format',
          message: 'Dit is geen geldig telefoonnumer',
        });
      }
    }
  }

  websiteChanged(e, value) {
    this.dirtyResources.website = true;
    this.formModel.website = value;
  }

  mailChanged(e, value) {
    this.dirtyResources.mail = true;
    this.formModel.mail = Object.fromEntries(
      Object.entries(value).filter(([, value]) => value != null)
    );
    if (this.ou) {
      this.addressHasChanged = true;
    }
  }

  countryChanged() {
    this.formModel.mail = {
      country: this.country.key,
      countryHref: this.country.$$meta.permalink,
    }
  }

  dateOfAddressChangeChanged(e, value) {
    this.dateOfAddressChangeWarnings = [];
    this.dirtyResources.dateOfAddressChange = true;
    this.formModel.dateOfAddressChange = value;
    if (isBefore(value, this.ou.currentSeat.startDate)) {
      this.dateOfAddressChangeWarnings = [
        { message: 'Deze datum ligt voor de start datum van het huidige zeteladres. Dit kan tot gevolg hebben dat je zeteladressen verwijderd uit de historiek.' },
      ];
    }
  }

  // ++++++++++++++++++++++++ ACCOUNTING DETAILS ++++++++++++++++++++++++

  accountingEmailChanged(e, value) {
    this.dirtyResources.accountingEmail = true;
    this.formModel.accountingEmail = value;
  }

  accountingBouwdossiersEmailChanged(e, value) {
    this.dirtyResources.accountingBouwdossiersEmail = true;
    this.formModel.accountingBouwdossiersEmail = value;
  }

  calculatePeppolWarningMsg() {
    // The peppol directory call does no longer work cross origin, so if we want to restore this we need to create a POST in Persons Api
    return;
    /* this.peppolWarningMsg = null;
    if (!this.ouTypeConfig || !this.ouTypeConfig.components.peppolMethod) {
      return;
    }
    if (this.formModel.peppolMethod === 'GLOBAL' && !this.ou.isKnownInPeppolDirectory) {
      this.peppolWarningMsg = 'Volgens de Peppol Directory gebruikt deze organisatie geen Peppol met zijn ondernemingsnummer als identificatienummer';
    } else if (this.formModel.peppolMethod === 'NONE' && this.ou.isKnownInPeppolDirectory) {
      this.peppolWarningMsg = 'Volgens de Peppol Directory gebruikt deze organisatie Peppol met zijn ondernemingsnummer als identificatienummer';
    } */
  }

  peppolMethodChanged(value) {
    this.dirtyResources.peppolMethod = true;
    this.formModel.peppolMethod = value;
    this.calculatePeppolWarningMsg();
  }

  // ++++++++++++++++++++++++ PAGE ACTIONS ++++++++++++++++++++++++++++

  removeNotification(ev, notificationKey) {
    this.$ngRedux.dispatch(removeNotification(notificationKey));
  }

  viewInApi() {
    if (this.ouTypeConfig.domain === 'sam') {
      window.open(
        `${this.settings.apis.kathOndVla}/sam/organisationalunits/view?key=${this.ouData.ouResource.key}`,
        '_blank'
      );
    } else {
      window.open(
        `${this.settings.apis.kathOndVla}/kathondvla/organisationalunits/vos-view/${this.ouData.ouResource.key}`,
        '_blank'
      );
    }
  }

  viewInTink() {
    const startYear = Number(getStartOfSchoolYear(getNow()).substring(0, 4));
    const tinkUrl = `https://tink.nascholing.be/${startYear}-${startYear+1}/Instelling?organisatie=${encodeURIComponent(this.ouData.ouResource.$$displayName)}`;
    window.open(tinkUrl, '_blank');
  }

  goToHome() {
    this.$state.go('home');
  }

  goToOrganisaties() {
    window.open(
      `${this.settings.applications.organisaties}/${this.ouData.ouResource.key}`,
      '_blank'
    );
  }

  createDeleteOuModal(respInfo, workgroup) {
    const startYear = Number(getStartOfSchoolYear(getNow()).substring(0, 4));
    const tinkUrl = `https://tink.nascholing.be/${startYear}-${startYear+1}/Instelling?organisatie=${encodeURIComponent(this.ouData.ouResource.$$displayName)}`;
    return this.$uibModal.open({
      animation: true,
      component: 'myConfirmModal',
      size: 'md',
      backdrop: 'static',
      resolve: {
        confirmationQuestion: () =>
          `Ben je zeker dat je ${this.ouTypeConfig.label} <strong>${this.formModel.name}</strong> wilt verwijderen?<br>
        Er zijn <strong>${respInfo.responsibilities.length} actieve verantwoordelijkheden</strong> (${respInfo.historicalResponsibilities.length} afgeschafte) verbonden aan deze ${this.ouTypeConfig.label}.<br>
        Er is <strong>${workgroup ? 'een' : 'geen'} werkgroep</strong> verbonden aan deze ${this.ouTypeConfig.label}.<br>
  Heb je nagekeken dat er geen <a target="_blank" href="${tinkUrl}">nascholingen</a> voor deze ${this.ouTypeConfig.label} zijn? Deze actie kan niet ongedaan gemaakt worden.`,
        icon: () => this.removeIcon,
        title: () => `${this.ouTypeConfig.label} verwijderen`,
      },
    });
  }

  async deleteOrganisation() {
    const respInfo = await getResponsibilities(this.ouData.ouResource.$$meta.permalink);
    const workgroup = await getWorkgroup(this.ouData.ouResource.$$meta.permalink);

    const removeMemberModal = this.createDeleteOuModal(respInfo, workgroup);

    removeMemberModal.result.then(async () => {
      try {
        const deleteOp = deleteOu(this.ouData);
        console.log('delete batch', deleteOp.batch);
        await sendBatch(deleteOp.batch);
        this.$ngRedux.dispatch(addSuccessNotification(`${this.ouTypeConfig.label} ${this.formModel.name} is succesvol verwijderd.`));
        if (workgroup) {
          await deleteWorkgroup(workgroup.$$meta.permalink);
          this.$ngRedux.dispatch(addSuccessNotification(`De werkgroep gekoppeld aan ${this.formModel.name} is succesvol verwijderd.`));
        }
      } catch (error) {
        console.error(error);
        this.$ngRedux.dispatch(addErrorNotification('Er is een onverwachte fout opgetreden'));
      }
      
    });
  }
  
  async changeType() {
    const modalInstance = this.$uibModal.open({
      animation: true,
      component: 'myOuAdminChangeTypeModal',
      size: 'md',
      backdrop: 'static',
      resolve: {
        ouTypes: () => Object.entries(OU_TYPE_CONFIG).filter(([key, value]) => value.domain === 'kathondvla').map(([key, value]) => ({ value: key, label: value.label })),
        currentType: () => this.ouType,
      },
    });

    modalInstance.result.then(async (newType) => {
      if (newType && newType !== this.ouType) {
        await sendBatch([{
          verb: 'PUT',
          href: this.ouData.ouResource.$$meta.permalink,
          body: {
            ...this.ouData.ouResource,
            type: newType,
          },
        }]);
        this.$ngRedux.dispatch(addSuccessNotification(`Het type van ${this.formModel.name} is succesvol gewijzigd naar ${OU_TYPE_CONFIG[newType].label}.`));
        this.ouType = newType;
        this.ouData.ouResource.type = newType;
        this.reset();
      }
    });
  }

  viesVatNumberChanged(e, value) {
    this.viesVatNumber = value;
  }

  viewInKbo(vatNumber) {
    const ondernemingsnummer = vatNumber ? vatNumber.substring(2) : this.formModel.companyNumber?.replace(/\D/g, '');
    window.open(`https://kbopub.economie.fgov.be/kbopub/zoeknummerform.html?nummer=${ondernemingsnummer}&actionLu=Zoek`, '_blank');
  }

  async importFromVies() {
    if (!this.viesVatNumber) {
      this.$ngRedux.dispatch(addErrorNotification('Vul een geldig BTW-nummer in.'));
      return;
    }
    if (!this.viesVatNumber.match(this.patterns.vatNumberPattern.pattern)) {
      this.$ngRedux.dispatch(addErrorNotification(this.patterns.vatNumberPattern.message));
      return;
    }
    this.isImportingFromVies = true;
    const countryCode = this.viesVatNumber.substring(0, 2).toUpperCase();
    try {
      this.legalFormList = await fetchLegalForms();
      await importViesOrg(this.viesVatNumber, this.formModel, this.dirtyResources);
      if (!this.countryList) {
        this.countryList = await fetchCountries();
      }
      this.country = this.countryList.find((country) => country.key === countryCode.toLowerCase());
      this.$ngRedux.dispatch(addSuccessNotification(`De gegevens ${this.viesVatNumber} konden worden opgehaald in Vies.`));
    } catch (error) {
      if (error.code === 'not.vat.registrered') {
        this.$ngRedux.dispatch(addErrorNotification(error.message));
      } else if (error.status === 404) {
        this.$ngRedux.dispatch(addErrorNotification(`${this.viesVatNumber} is geen geldig BTW-nummer in ${countryCode}.`));
      } else if (error.status === 400) {
        this.$ngRedux.dispatch(addErrorNotification(`${this.viesVatNumber} is geen geldig formmaat voor een BTW-nummer in ${countryCode}.`));
      } else {
        console.error(error)
      }
    } finally {
      this.isImportingFromVies = false;
      this.$scope.$apply();
    }
  }
}
